import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminUploadPagesListHeader = ({
  order,
  orderBy,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      <th className={`th-sortable${orderBy === 'title' ? ' active' : ''}`}>
        {intl.formatMessage({ defaultMessage: 'Title' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Collection' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Default file access' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Assigned to' })}
      </th>
      <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'created_at'); }}>
          {intl.formatMessage({ defaultMessage: 'Created' })}
          {' '}
          {orderBy === 'created_at' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminUploadPagesListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminUploadPagesListHeader;
